var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26 26",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "98.993048%",
    id: "b3ipxzugda"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C45EE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F40CA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "u9uqrs3uab",
    d: "M0 0H12V12H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.580634,11.758318 C24.580634,5.362552 19.395766,0.177684 13,0.177684 C6.604182,0.177684 1.419366,5.362552 1.419366,11.758318 C1.419366,15.508896 3.202836,18.842408 5.967416,20.958782 L5.966064,20.958782 L5.979896,20.96835 C6.268912,21.189012 13,25.822316 13,25.822316 C13,25.822316 19.73114,21.18896 20.020208,20.968246 L20.033208,20.959276 L20.031934,20.959276 C22.796878,18.842954 24.580634,15.509182 24.580634,11.758318 Z",
    fill: "url(#b3ipxzugda)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dy0hsx9v3c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u9uqrs3uab"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0.5 C9.01283584,0.5 9.43550716,0.88604019 9.49327227,1.38337887 L9.5,1.5 C10.6045695,1.5 11.5,2.3954305 11.5,3.5 L11.5,9.5 C11.5,10.6045695 10.6045695,11.5 9.5,11.5 L2.5,11.5 C1.3954305,11.5 0.5,10.6045695 0.5,9.5 L0.5,3.5 C0.5,2.3954305 1.3954305,1.5 2.5,1.5 L2.75,1.5 C2.75,0.94771525 3.19771525,0.5 3.75,0.5 L8.5,0.5 Z M8.375,7.75 L3.625,7.75 C3.41789322,7.75 3.25,7.91789322 3.25,8.125 C3.25,8.33210678 3.41789322,8.5 3.625,8.5 L3.625,8.5 L8.375,8.5 C8.58210678,8.5 8.75,8.33210678 8.75,8.125 C8.75,7.91789322 8.58210678,7.75 8.375,7.75 L8.375,7.75 Z M8.375,5.25 L3.625,5.25 C3.41789322,5.25 3.25,5.41789322 3.25,5.625 C3.25,5.83210678 3.41789322,6 3.625,6 L3.625,6 L8.375,6 C8.58210678,6 8.75,5.83210678 8.75,5.625 C8.75,5.41789322 8.58210678,5.25 8.375,5.25 L8.375,5.25 Z M9.5,1.50380371 L2.75,1.50380371 L2.75,1.75380371 C2.75,2.30608846 3.19771525,2.75380371 3.75,2.75380371 L8.5,2.75380371 C9.05228475,2.75380371 9.5,2.30608846 9.5,1.75380371 L9.5,1.50380371 Z",
    fill: "#FFF",
    mask: "url(#dy0hsx9v3c)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkPurple);
export default __webpack_public_path__ + "static/media/mark_purple.088f76227ae43e7f9c43fde3ba72cf65.svg";
export { ForwardRef as ReactComponent };